import axiosInstance from '../../../../utils/axiosInstance';

// =============================================
// ADMIN CONTRACTS
// =============================================

export const getContracts = async () => {
  const { data } = await axiosInstance.get('/admin/contracts/');
  return data;
};

export const getContractById = async (contractId) => {
  const { data } = await axiosInstance.get(`/admin/contracts/${contractId}/`);
  return data;
};

export const updateContractStatus = async (contractId, status) => {
  const { data } = await axiosInstance.put(`/admin/contracts/${contractId}/status/`, { status });
  return data;
};

export const generateContractPdf = async (contractId) => {
  const response = await axiosInstance.get(`/admin/contracts/${contractId}/pdf/`, {
    responseType: 'blob',
  });
  return response.data;
};
